export enum UserProfileMenuItemType {
  SignOut = 'sign-out',
  SwitchView = 'switch-view',
  ViewProfile = 'view-profile',
}
